import { Badge } from '@/components/ui/badge';
import { statusEntry, type StatusKind } from '@/lib/status-map';
import { cn } from '@/lib/utils';

/**
 * The one status badge (audit C1) — renders any status from `STATUS_MAP`
 * with its contracted label + tone. Replaces every hand-rolled
 * `FindingStatusBadge` / status pill. Unknown status → em-dash.
 */
export function StatusBadge({
  kind = 'finding',
  status,
  className,
}: {
  kind?: StatusKind;
  status: string;
  className?: string;
}) {
  const entry = statusEntry(kind, status);
  if (entry === null) {
    return <span className={cn('text-xs text-brand-slate', className)}>—</span>;
  }
  return (
    <Badge tone={entry.tone} soft={entry.soft} className={className}>
      {entry.label}
    </Badge>
  );
}
